"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.HybridListState = void 0;
/*************************************************************************
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 * Copyright 2022 Adobe
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains
 * the property of Adobe and its suppliers, if any. The intellectual
 * and technical concepts contained herein are proprietary to Adobe
 * and its suppliers and are protected by all applicable intellectual
 * property laws, including trade secret and copyright laws.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe.
 **************************************************************************/

const AlphaListState_1 = require("./AlphaListState");

const types_1 = require("./types");

class HybridListState extends AlphaListState_1.AlphaListState {
  /** Constructor for HybridListState model Objects. This supports list services that can not use next-token paging when searching. */
  constructor(options) {
    super(options);
    this.itemCount = 0;
    this.pageCount = 0;
    this.itemCount = 0;
    this.pageCount = 0;
  }
  /** Goes to the next page. */


  goToNextPage() {
    if (this.filterQuery.length < this.filterQueryMinLength) {
      super.goToNextPage();
    } else {
      this.setPage(this.pageNumber + 1);
    }
  }
  /** Goes to the previous page. */


  goToPreviousPage() {
    if (this.filterQuery.length < this.filterQueryMinLength) {
      super.goToPreviousPage();
    } else {
      this.setPage(this.pageNumber - 1);
    }
  }
  /** Returns true if there is a next page. */


  hasNextPage() {
    return this.filterQuery.length < this.filterQueryMinLength ? super.hasNextPage() : this.pageNumber < this.pageCount;
  }
  /** Returns true if there is a previous page. */


  hasPreviousPage() {
    return this.filterQuery.length < this.filterQueryMinLength ? super.hasPreviousPage() : this.pageNumber > 1;
  }
  /** Sets the `pageNumber` if the `newPage` differs. */


  setPage(newPage) {
    if (newPage > 0 && newPage !== this.pageNumber) {
      // valid page (starts at zero and not same page that is currently selected)
      this.pageNumber = newPage;
    }
  }
  /** Gets the paging properties from response headers and sets them to internal properties. */


  setResponseAndHeaders(response, headers) {
    if (this.filterQuery.length >= this.filterQueryMinLength) {
      this.itemCount = parseInt(headers.get(types_1.JIL_HEADERS.TOTAL_COUNT), 10) || 0;
      this.pageCount = parseInt(headers.get(types_1.JIL_HEADERS.PAGE_COUNT), 10) || 0;
    }

    super.setResponseAndHeaders(response, headers);
  }
  /** Returns a collection of data to send to services to handle pagination. */


  toQueryParams() {
    // ACP paging does not support searching so we should call index paging api when searching
    return this.filterQuery.length < this.filterQueryMinLength ? super.toQueryParams() : {
      page: this.pageNumber - 1,
      page_size: this.pageSize,
      search_query: this.filterQuery,
      sort: this.sortKey,
      sort_order: this.sortReverse ? types_1.SortOrder.DESC : types_1.SortOrder.ASC
    };
  }

}

exports.HybridListState = HybridListState;
exports.default = HybridListState;